import React from "react";
import SignUpForm from "../components/forms/signUpForm/SignUpForm";
import LayoutWrapper from "../layout/layoutWrapper/LayoutWrapper";
import { Helmet } from "react-helmet";


const Signup = () => {
  return (
    <>
    
    <Helmet>
  <title>Create an Inkox Account to Start Designing Your Products Today
</title>
  <meta name="description" content="Sign up for Inkox to start designing and ordering custom apparel. Fast, easy setup with access
to exclusive tools and order tracking" />
</Helmet>
    <LayoutWrapper>
    <div className="signUp">
      <SignUpForm />
    </div>
        </LayoutWrapper>
        </>

  );
};

export default Signup;
